// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1eK8x","calendarButtons":"ClockData_calendarButtons__3u9tK"};